import React, { Component } from "react";

export default class CubeCountingSection extends Component {
  render() {
    var {
      cube_countring_score,
      cube_status_1,
      cube_status_2,
      cube_status_3,
      cube_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <hr />
          <ul style={{ paddingLeft: 20, fontSize: 19 }}>
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Ask the person “to count the cubes are in each structure
                  progress period” Progress from left to right and top to bottom
                  to move through the cube structures. All structures should be
                  attempted.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Scoring: one point for each correct answer.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  ‘How many cubes are in each structure, including the ones you
                  may not be able to see?’
                </li>
              </ul>
            </li>
          </ul>
          <hr />
          <div className="row">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>1) Correct Answer:</b> 5
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/cube-images/1.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={cube_status_1 == "0" ? false : true}
                  name="cube_status_1"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>2) Correct Answer:</b> 6
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/cube-images/2.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={cube_status_2 == "0" ? false : true}
                  name="cube_status_2"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>3) Correct Answer:</b> 10
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/cube-images/3.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={cube_status_3 == "0" ? false : true}
                  name="cube_status_3"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>4) Correct Answer:</b> 7
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/cube-images/4.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={cube_status_4 == "0" ? false : true}
                  name="cube_status_4"
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <br />
            <span className="fs-19">Score (0-4) </span>
            <input
              type="number"
              disabled
              name="cube_countring_score"
              value={cube_countring_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
